import { makeRule } from '@core/utils/rule.js'

// 人事-员工管理 搜索表单校验（均为可选项）
export const searchRules = {
  name: [
    {...makeRule('请输入员工姓名', 'string', 'blur', false)},
  ],
  status: [
    {...makeRule('请选择员工状态', 'integer', 'change', false)},
  ],
  phone: [
    {
      ...makeRule('请输入正确的手机号', 'string', 'blur', false),
      pattern: /^1[3456789]\d{9}$/i,
    },
  ],
  email: [
    {...makeRule('请输入正确的邮箱', 'email', 'blur', false)},
  ],
}

// 人事-员工管理 新增/编辑表单校验（必填项）
export const formRules = {
  name: [
    {...makeRule('请输入员工姓名', 'string')},
  ],
  gender: [
    {...makeRule('请选择性别', 'integer', 'change')},
  ],
  phone: [
    {
      ...makeRule('请输入正确的手机号', 'string'),
      pattern: /^1[3456789]\d{9}$/i,
    },
  ],
  email: [
    {...makeRule('请输入正确的邮箱', 'email')},
  ],
  birthday: [
    {...makeRule('请选择生日', 'date', 'change')},
  ],
  hire_date: [
    {...makeRule('请选择入职日期', 'date', 'change')},
  ],
  status: [
    {...makeRule('请选择员工状态', 'integer', 'change')},
  ],
}





// WEBPACK FOOTER //
// ./src/views/hr/hr.rules.js